<template>
    <tr>
        <td>{{ index +1}}</td>
        <td>
            <div class="form-group" :class="{ 'form-group--error': $v.label.$error }">
                <input class="form__input" v-model.trim="$v.label.$model"/>
                <!-- <label class="form__label" :class="{'up': $v.label.$model }">Rótulo</label> -->
                <div class="error" v-if="!$v.label.required">Rótulo é obrigatório</div>
            </div>
        </td>
        <td>
            <div class="form-group">
                <input class="form__input" v-model="min"/>
                <!-- <label class="form__label" :class="{'up': $v.min.$model }">Valor mínimo</label> -->
                <!-- <div class="error" v-if="!$v.min.required">Valor mínimo é obrigatório</div> -->
            </div>
        </td>
        <td>
            <div class="form-group" :class="{ 'form-group--error': $v.max.$error }">
                <input class="form__input" v-model.trim="$v.max.$model"/>
                <!-- <label class="form__label" :class="{'up': $v.max.$model }">Valor máximo</label> -->
                <div class="error" v-if="!$v.max.required">Valor máximo é obrigatório</div>
            </div>
        </td>
        <td>
            <div class="form-group" :class="{ 'form-group--error': $v.metric.$error }">
                <input class="form__input" v-model.trim="$v.metric.$model"/>
                <!-- <label class="form__label" :class="{'up': $v.metric.$model }">Métrica</label> -->
                <div class="error" v-if="!$v.metric.required">Métrica é obrigatória</div>
            </div>
        </td>
        
        <td style="width: 95px">
            <button type="button" class="button red" @click="remove(index)"><i class="mdi mdi-trash-can-outline"></i></button>
            <button v-if="preventLabel != label || preventMin != min || preventMax != max || preventMetric != metric || preventType != type" type="button" class="button" @click="save()"><i class="mdi mdi-content-save-outline"></i></button>
        </td>
    </tr>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: "Attribute",
    data(){
        return {
            preventLabel: '',
            preventMin: '',
            preventMax: '',
            preventMetric: '',
            preventType: '',

        }
    },
    validations: {
        label: {
            required,
        },
        max: {
            required,
        },
        metric: {
            required,
        },
        type: {
            required,
        }
    },
    props: {
        index: {
            type: Number
        },
        remove:{
            type: Function
        },
        label: {
            type: [String, Number]
        },
        min: {
            type: [String, Number]
        },
        max: {
            type: [String, Number]
        },
        metric: {
            type: [String, Number]
        },
        
        change: {
            type: Function
        }
    },
    mounted(){
        this.definePrevent()
    },
    watch: {
        index: {
            immediate: true,
            deep: true,
            handler(nV){
                console.log(nV)
                this.definePrevent()
            }
        }
        // label(nV){
        //     this.change('label', nV)
        // },
        // value(nV){
        //     this.change('value', nV)
        // }
    },
    methods:{
        definePrevent(){
            this.preventLabel = this.label
            this.preventMin = this.min
            this.preventMax = this.max
            this.preventMetric = this.metric
        },
        save(){
            let data = {
                label: this.label,
                min: this.min,
                max: this.max,
                metric: this.metric,
            }
            this.change(this.index, data)
            this.definePrevent()
        }
    }
}
</script>